import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {action} from 'redux/helpers';
import {settingsTypes} from 'redux/settings';
import {IAdminRoles} from 'types/diplomat/settings/adminroles/AdminRoles';

export const useUpdateAdminRole = () => {
   const dispatch = useDispatch();
   const update = useCallback(
      (roles?: IAdminRoles) => {
         dispatch(action(settingsTypes.UPDATE_ADMIN_ROLES.SAGA, roles));
      },
      [dispatch]
   );

   return update;
};
